export default __webpack_public_path__ + "static/media/rnr-sports-table-11-cn.df68881d.webp";